/*
* [Add to bundle, Remove from bundle, Open quickview popup, Add to bundle from quickview popup]
*
* Date:    [18/09/2024]
* Author:  ["GH@BM"]
* AB Test: [TRTL Travel130: Build Your Bundle LP]
* See:     []
*/


document.addEventListener("DOMContentLoaded", function() {
  // Variables
  var currencySymbol = document.querySelector(".collection-bundle-progressbar-header").dataset.currencySymbol;
  var products = document.querySelectorAll(".gh-bundle-products-cta--form");
  var bundleList = document.querySelector(".gh-footer-sticky-atc-wrapper .product-image-wrapper");
  var stickyAtcBar = document.querySelector(".gh-footer-sticky-atc-wrapper");
  var progressbarWrapper = document.querySelector(".gh-progressbar-area");
  var atcBtn = document.querySelector("[js-add-bundle-to-cart");
  var bundleItems = [];
  var currentStepData = null;

  // Open sidecart and populate data
  function loadAjaxCart() {
    fetch("/cart?view=ajax", {
      method: "GET",
      headers: {
        "Content-Type": "application/Html",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((cartData) => {
      var update_cart_content = document.querySelector(".cart-item__wrapper");
      update_cart_content.innerHTML = cartData;
      var header_cart_quantitys = document.querySelectorAll("[data-cart-item-count]");
      var cart_item_count = update_cart_content.querySelector(".cart-item__extra_info").dataset.item_count;
      var cart_total_price = update_cart_content.querySelector(".cart-item__extra_info").dataset.total_price;
      document.querySelector(".cart_item-count").innerHTML = cart_item_count;
      document.querySelector(".cart_item-total-price").innerHTML = cart_total_price;
      header_cart_quantitys.forEach(function (header_cart_quantity) {
        header_cart_quantity.innerHTML = cart_item_count.split(" ")[0];
        header_cart_quantity.dataset.cartItemCount = cart_item_count.split(" ")[0];
      });
      document.querySelector(`#navbar a[href="#cart-offcanvas"]`).click();
      document.querySelector(".cart_checkout-button").classList.remove("d-none");

      atcBtn.classList.remove("loading");
      bundleItems = [];
      refreshOrResetProducts(true);
    })
    .catch((error) => {
      console.log("Error:", error);
      atcBtn.classList.remove("loading");
      bundleItems = [];
      refreshOrResetProducts(true);
    });
  }

  // Function to add all products to cart
  function addToCart() {
    var data = bundleItems.map(item => (
      { 
        id: item.id, 
        quantity: item.quantity,
        properties: {
          _gh_bundle: true
        }
      }
    ));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: data }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add products to cart: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Products added to cart:', data);
      loadAjaxCart();
    })
    .catch(error => {
      console.error(error);
      refreshOrResetProducts(true);
    });
  }

  // Function to add to the bundle
  function addToBundle(variantId, variantImage, variantPrice, variantComparePrice) {
    var existingItem = bundleItems.find(function(item) {
      return item.id === variantId;
    });

    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      bundleItems.push({
        id: variantId,
        quantity: 1,
        thumbnail: variantImage,
        price: variantPrice,
        comparePrice: variantComparePrice
      });

      refreshOrResetProducts();
    }
  }

  // Function to remove from bundle
  function removeFromBundle(variantId) {
    var itemIndex = bundleItems.findIndex(function(item) {
      return item.id === variantId;
    });
    
    if (itemIndex > -1) {
      if (bundleItems[itemIndex].quantity > 1) {
        bundleItems[itemIndex].quantity = bundleItems[itemIndex].quantity - 1;
      } else {
        bundleItems.splice(itemIndex, 1);
      }
      refreshOrResetProducts();
    }
  }

  // Function to adjust quantity
  function adjustQuantity(variantId, quantity) {
    var existingItem = bundleItems.find(function(item) {
      return item.id === variantId;
    });

    if (existingItem) {
      existingItem.quantity = quantity;
      if (existingItem.quantity <= 0) {
        removeFromBundle(variantId);
      }
    }

    refreshOrResetProducts();
  }

  // Function to update variant
  function updateVariantSelect(product, target) {
    var select = product.querySelector("select");
    var inputs = product.querySelectorAll("input:checked");
    var selectedOptionName = Array.from(inputs).map(input => input.value).join(" / ");
    var option = Array.from(select.options).find(opt => opt.dataset.name === selectedOptionName);
    
    if (option) {
      select.value = option.value;
      select.selectedIndex = option.index;
      select.dispatchEvent(new Event("change"));

      if (product.classList.contains("multiple-options")) {
        var optionIndex = target.dataset.optionIndex;
        var productOptions = product.querySelectorAll(`.option__values input:not([data-option-index="${optionIndex}"])`);
        productOptions.forEach(po => {
          po.disabled = true;

          Array.from(select.options).forEach(opt => {
            var optionNames = opt.dataset.name.split(" / ");
            if (optionNames.includes(target.value) && optionNames.includes(po.value) && opt.disabled == false) {
              po.disabled = false;
            }
          })
        });
      }

      enableDisableProductATC(product);
      toggleAddToBundleBtn();
      updateProductPrice(product, option);
    }

    // update the slider
    var targetSrc = option.dataset.image;
    var swiperContainer = product.closest('.bundle-products__product-block').querySelector('.bundle-products__product--images');
    var swiper = swiperContainer.swiper;
    swiper.slides.forEach((slide, index) => {
      var img = slide.querySelector('img');
      if (img && img.getAttribute('src') === targetSrc) {
        swiper.slideTo(index);
      }
    });
  }

  // function to update compare at price
  function updateProductPrice(product, option) {
    var regularPrice = option.dataset.price;
    var comparePrice = option.dataset.comparePrice;
    var regularContainer = product.parentElement.querySelectorAll(".bundle-products__product--details-price .regular");
    var compareContainer = product.parentElement.querySelectorAll(".bundle-products__product--details-price .compare");

    regularContainer.forEach(item => {
      item.innerHTML = currencySymbol + regularPrice;
    })
    if (comparePrice != "0.00") {
      compareContainer.forEach(item => {
        item.innerHTML = currencySymbol + comparePrice;
      })
    } else {
      compareContainer.forEach(item => {
        item.innerHTML = "";
      })
    }
  }

  // Function to enable/disable product add to cart button
  function enableDisableProductATC(product) {
    var select = product.querySelector("select");
    var inputs = product.querySelectorAll("input:checked");
    var selectedOptionName = Array.from(inputs).map(input => input.value).join(" / ");
    var option = Array.from(select.options).find(opt => opt.dataset.name === selectedOptionName);
    var atc = product.querySelector("[js-add-bundle-to-list]");

    // console.log('>> option', option);

    if (option && option.disabled) {
      atc.disabled = true;
    } else {
      atc.disabled = false;
    }
  }

  // Function to hide add to bundle button
  function toggleAddToBundleBtn() {
    products.forEach(function(product) {
      var selects = product.querySelectorAll("select");
      var atcButtonWrapper = product.querySelector(".gh-bundle-products-cta__atc");
      var shouldHideButton = false;

      selects.forEach(function(select) {
        for (let j = 0; j < bundleItems.length; j++) {
          if (select.value == bundleItems[j].id) {
            select.parentElement.querySelector(".atc__qty-adjust input").value = bundleItems[j].quantity;
            shouldHideButton = true;
            break;
          }
        }
        
        if (shouldHideButton) {
          atcButtonWrapper.classList.add("hide-atc");
        } else {
          atcButtonWrapper.classList.remove("hide-atc");
        }
      });
    });
  }

  // Function to update progressbar
  function updateProgressbar() {
    var progressbarMessage = progressbarWrapper.querySelector(".gh-progressbar-message p");
    var progressbarMessageFooter = stickyAtcBar.querySelector(".offer-message");
    var progressbarPercent = progressbarWrapper.querySelector(".progress-bar");
    var progressbarSteps = progressbarWrapper.querySelectorAll(".progress-steps-wrapper .progress-steps-item");
    
    if (progressbarMessage && progressbarMessage.dataset.progressSteps) {
      var totalPrice = bundleItems.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0); // Ensure totalPrice is a decimal with 2 points
      
      var steps = JSON.parse(progressbarMessage.dataset.progressSteps);
      var currentStep = null;
      var nextStep = null;
      var nextStepAmount = null;

      // Convert steps data to number
      steps.forEach(item => {
        item.step = Number(item.step);
        item.threshold = Number(item.threshold);
        item.discount = Number(item.discount);
      });
  
      // Determine the current step and next step amount
      for (var i = 0; i < steps.length; i++) {
        if (totalPrice >= steps[i].threshold) {
          currentStep = steps[i];
          nextStepAmount = steps[i + 1] ? (steps[i + 1].threshold - totalPrice) : null;
          nextStep = steps[i + 1] ? steps[i + 1] : null;
        } else {
          break;
        }
      }
  
      // Calculate progress percentage
      var progressPercent = 0;
      var stepLength = steps.length - 1;
      var stepLengthPercent = 100.00 / steps.length;
      var stepLengthMaxPercent = stepLengthPercent * stepLength;
      if (currentStep && nextStep) {
        progressPercent = ((totalPrice / nextStep.threshold) * stepLengthMaxPercent) / stepLength;
        progressPercent = progressPercent + ((currentStep.step - 1) * stepLengthPercent)
      } else if (currentStep) {
        progressPercent = 100;
      }
      
      // Prepare the message
      var message = currentStep ? currentStep.message.replace('{amount}', nextStepAmount !== null ? currencySymbol + nextStepAmount.toFixed(2) : currencySymbol + '0.00') : '';
      
      currentStepData = {
        currentStep: currentStep ? currentStep.step : "0",
        message: message,
        progressPercent: Math.round(progressPercent),
        discount: currentStep.discount || null
      };
  
      // Update the UI
      progressbarMessage.innerHTML = currentStepData.message.replace("<br>", "");
      progressbarMessageFooter.innerHTML = currentStepData.message;
      progressbarPercent.style.width = currentStepData.progressPercent + '%'; // Add '%' for the width
      for (let i = 0; i < progressbarSteps.length; i++) {
        if (i+1 < currentStep.step) {
          progressbarSteps[i].classList.add("active");
        } else {
          progressbarSteps[i].classList.remove("active");
        }
      }
    }
  }

  // Function to update sticky atc
  function updateStickyAtcBar() {
    if (bundleItems.length) {
      stickyAtcBar.classList.remove("no-products");

      // build element
      var bundleItemHtml = "";
      bundleItems.forEach(function(item) {
        for (let i = 0; i < item.quantity; i++) {
          var htmlString =''+ 
          '  <div class="product-img">'+ 
          '      <img class="product-main-img" src="'+item.thumbnail+'">'+ 
          '      <svg class="cross-icon" data-variant-id="'+item.id+'" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <g opacity="0.5"> <path d="M1 1L9 9" stroke="black"/> <path d="M9 1L0.999999 9" stroke="black"/> </g> </svg>'+ 
          '  </div>';
          bundleItemHtml += htmlString;
        }
      })
      bundleList.innerHTML = bundleItemHtml;
    } else {
      stickyAtcBar.classList.add("no-products");
      bundleList.innerHTML = "";
    }

    // update price
    var priceEl = stickyAtcBar.querySelector(".current-price");
    var comparePriceEl = stickyAtcBar.querySelector(".compare-price");
    var price = bundleItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    var comparePrice = 0;

    if (currentStepData && currentStepData.discount != null) {
      comparePrice = price;
      price = price * (1 - (currentStepData.discount / 100))
    } else {
      price = price;
      comparePrice = 0;
    }
    
    priceEl.innerHTML = currencySymbol + price.toFixed(2);
    if (comparePrice > 0) {
      comparePriceEl.innerHTML = currencySymbol + comparePrice.toFixed(2);
    } else {
      comparePriceEl.innerHTML = "";
    }

    // update product count message
    var productCount = stickyAtcBar.querySelector(".product-quantity p");
    var productsInBundleMessage = "Start adding products";
    if (bundleItems.length > 0) {
      var totalItems = bundleItems.reduce((sum, item) => sum + item.quantity, 0);
      productsInBundleMessage = totalItems + " Products";
    }
    productCount.innerHTML = productsInBundleMessage;
  }

  // Function to reset/refresh al products after add to cart
  function refreshOrResetProducts(reset = false) {
    if (reset) {
      products.forEach(function(product) {
        product.querySelector(".atc__qty-adjust input").value = 1;
      })
    }

    toggleAddToBundleBtn();
    updateProgressbar();
    updateStickyAtcBar();
  }
  
  products.forEach(function(product) {
    var inputs = product.querySelectorAll('input[type="radio"]');
    var select = product.querySelector("select");

    // update atc status on initial state
    enableDisableProductATC(product);

    // On product variant change
    inputs.forEach(function(input) {
      input.addEventListener("click", function(e) {
        updateVariantSelect(product, e.target)
      })
    })

    // Add to bundle buttons
    var addToBundleCta = product.querySelectorAll("[js-add-bundle-to-list]");
    addToBundleCta.forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        var variantId = select.value;
        var variantImage = select.options[select.selectedIndex].dataset.thumbnail;
        var variantPrice = select.options[select.selectedIndex].dataset.price;
        var variantComparePrice = select.options[select.selectedIndex].dataset.comparePrice;
        addToBundle(variantId, variantImage, variantPrice, variantComparePrice);
        e.target.parentElement.querySelector(".atc__qty-adjust input").value = 1;
      });
    });

    // Quantity adjust buttons
    var qtyAdjustBtn = product.querySelectorAll(".atc__qty-adjust button");
    qtyAdjustBtn.forEach(function(qtyAdjust) {
      qtyAdjust.addEventListener("click", function(e) {
        e.preventDefault();
        var inputQty = e.target.parentElement.querySelector("input");
        var qtyVal = parseInt(inputQty.value);

        if (e.target.classList.contains("qty-adjust--plus")) {
          qtyVal = qtyVal + 1;
        } else {
          if (qtyVal > 0) {
            qtyVal = qtyVal - 1;
          }
        }
        inputQty.value = qtyVal;
        adjustQuantity(select.value, qtyVal);
      });
    });
  })

  // Remove from bundle
  bundleList.addEventListener("click", function(e) {
    e.preventDefault();
    if (e.target.classList.contains("cross-icon")) {
      var variantId = e.target.dataset.variantId;
      removeFromBundle(variantId);
    }
  });

  // Add to cart
  atcBtn.addEventListener("click", function(e) {
    e.preventDefault();
    atcBtn.classList.add("loading");
    addToCart();
  })
})